module.exports = __webpack_public_path__ + "img/prioritas_vippack_cod_dg_k.f90f9d97.png";